<template>
  <v-card v-bind:class="actionClass">
    <!-- Info meta info -->
    <v-toolbar flat color="#f5fff5">
      <v-toolbar-title class="blue-grey--text">
        <span class="subtitle-1">{{ $t('info') }}</span>
        <span class="caption pl-2">LVL {{ level }}</span>
        <span class="caption pl-2">IDX {{ index }}</span>
      </v-toolbar-title>
      <v-spacer class="handle"></v-spacer>
      <v-menu open-on-hover left offset-x v-if="toolbarEnabled">
        <template v-slot:activator="{ on }">
          <v-btn icon class="caption" v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-btn text icon :title="copyTitle" :color="inCopy ? 'grey' : 'black'" @click="copy">
            <v-icon>file_copy</v-icon>
          </v-btn>
          <v-btn text icon :title="cutTitle" :color="inCut ? 'grey' : 'black'" @click="cut">
            <v-icon>flip_to_back</v-icon>
          </v-btn>
          <v-btn text icon color="error" :title="$t('remove')" @click="remove">
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- Input fields editor -->
    <v-container fluid>
      <v-layout>
        <v-flex>
          <v-text-field v-model="localLabel" :label="$t('label')" data-test="checklist-info-label"></v-text-field>
        </v-flex>
        <v-flex v-if="selectedLanguage" class="ml-3">
          <v-text-field v-model="localTranslatedLabel" :label="translatedLabel"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-text-field
            v-model="localDescription"
            :label="$t('description')"
            data-test="checklist-info-description"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="selectedLanguage" class="ml-3">
          <v-text-field v-model="localTranslatedDescription" :label="translatedDescription"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import editorMixins from './editor-mixins.es6'

export default {
  name: 'info-editor',
  mixins: [editorMixins],
  props: {
    level: Number,
    index: Number,
    type: String,
    label: String,
    description: String,
    translation: Object
  }
}
</script>
